import { EntityReference, ProductQuantityUnit, ProductStockItem } from '../../core/api/api.entities';
import { ProductAction } from '../../core/api/products/entities/product-action.entity';
import { ProductCategoryStockItemRow } from '../../features/stock/product-categories/models/product-category-stock-item-row.model';
import { ProductWithBarcode } from '../../shared/models/product-with-barcode.model';
import { QuickActionFormControls } from '../form-controls/quick-action.form-controls';
import { QuickActionFormOptions } from '../form-options/quick-action.form-options';
import { BaseForm } from './base.form';

export abstract class QuickActionForm<T extends QuickActionFormControls> extends BaseForm<T> {
  public abstract get amountHint(): string | undefined;
  public abstract get productAction(): ProductAction;
  public abstract get quantityUnit(): ProductQuantityUnit | undefined;
  public abstract canSelectStockItem(stockItem: ProductStockItem): boolean;
  public abstract setAmountToMax(): void;
  protected abstract setChangeListeners(): void;
  protected abstract setInitialValues(): void;

  override options = new QuickActionFormOptions();

  protected _product?: ProductWithBarcode;
  protected _stockItem?: ProductCategoryStockItemRow;

  get amount(): number {
    return this.formGroup.controls.amount.value;
  }

  override get controls(): T {
    return this.formGroup.controls as T;
  }

  get currentLocations(): EntityReference[] {
    return this.product?.activeStockItems.map(si => this.options.locations.find(l => l.id === si.locationId)!) || [];
  }

  get locationOptions(): EntityReference[] {
    return this.options.locations;
  }

  get quantityUnitName(): string {
    if (this.quantityUnit) {
      return this.amount === 1 ? this.quantityUnit.name : this.quantityUnit.namePlural;
    } else return '';
  }

  get product(): ProductWithBarcode | undefined {
    return this._product;
  }

  set product(product: ProductWithBarcode | undefined) {
    this._product = product;
    this.setInitialValues();
    this.setChangeListeners();
  }

  get stockItem(): ProductCategoryStockItemRow | undefined {
    return this._stockItem;
  }

  set stockItem(stockItem: ProductCategoryStockItemRow | undefined) {
    this._stockItem = stockItem;

    if (stockItem) {
      this.controls.stockItem.setValue(stockItem);
      this.controls.stockItem.disable();
    }
  }

  disable(): void {
    for (const control in this.controls) {
      this.controls[control].disable();
    }
  }

  enable(): void {
    for (const control in this.controls) {
      this.controls[control].enable();
    }
  }
}
